import React from "react";
import { createIcon } from "@chakra-ui/icon";

export const AppIcon = createIcon({
  displayName: "AppIcon",
  viewBox: "0 0 315.000000 316.000000",
  path: (
    <g
      transform="translate(0.000000,316.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path
        d="M1392 3074 c-14 -9 -24 -30 -28 -56 -12 -75 -21 -78 -210 -78 l-166
    0 -26 -30 -26 -30 -226 0 c-250 0 -259 -2 -286 -66 -21 -50 -21 -2618 0 -2668
    30 -71 -61 -66 1163 -66 l1103 0 32 29 33 29 0 1342 0 1342 -33 29 -32 29
    -236 0 -236 0 -28 30 -28 30 -161 0 c-148 0 -163 2 -181 20 -11 11 -20 33 -20
    50 0 19 -9 40 -25 55 -24 25 -27 25 -192 25 -136 0 -173 -3 -191 -16z m-492
    -273 c0 -4 -16 -42 -35 -84 -19 -42 -35 -85 -35 -96 l0 -21 744 0 c483 0 747
    3 751 10 3 5 -12 50 -34 100 -23 49 -41 92 -41 95 0 3 91 5 203 5 145 0 206
    -3 215 -12 9 -9 12 -316 12 -1320 0 -1282 0 -1307 -19 -1318 -27 -14 -2125
    -14 -2152 0 -19 11 -19 36 -19 1320 0 1236 1 1310 18 1319 21 13 392 15 392 2z"
      />
      <path
        d="M580 1495 l0 -1235 1005 0 1005 0 0 1235 0 1235 -125 0 -124 0 19
    -42 c36 -80 18 -130 -52 -143 -18 -3 -360 -5 -760 -3 l-726 3 -27 25 c-30 28
    -30 57 -1 123 l16 37 -115 0 -115 0 0 -1235z m840 880 c11 -13 -11 -40 -151
    -180 l-163 -165 -82 81 c-78 78 -94 109 -56 109 9 0 42 -26 74 -57 l58 -58
    143 143 c78 78 147 142 153 142 6 0 17 -7 24 -15z m-160 -42 c0 -4 -10 -17
    -22 -30 -21 -22 -27 -23 -185 -23 l-163 0 0 -155 0 -155 160 0 160 0 0 53 c0
    44 4 58 25 77 l25 23 0 -106 0 -107 -215 0 -215 0 0 215 0 215 215 0 c118 0
    215 -3 215 -7z m1060 -158 l0 -25 -395 0 -395 0 0 25 0 25 395 0 395 0 0 -25z
    m0 -145 l0 -30 -395 0 -395 0 0 30 0 30 395 0 395 0 0 -30z m-902 -336 c2 -13
    -46 -67 -158 -179 l-160 -160 -82 82 c-78 78 -82 84 -65 100 16 16 20 14 82
    -47 l65 -65 148 148 c81 81 151 146 157 144 5 -2 11 -12 13 -23z m-178 -59
    c-23 -25 -26 -25 -187 -25 l-163 0 0 -160 0 -160 160 0 160 0 0 53 c0 44 4 58
    25 77 l25 23 0 -101 0 -102 -215 0 -215 0 0 210 0 210 217 0 216 0 -23 -25z
    m1080 -135 l0 -30 -395 0 -395 0 0 30 0 30 395 0 395 0 0 -30z m0 -150 l0 -30
    -395 0 -395 0 0 30 0 30 395 0 395 0 0 -30z m-1060 -575 l0 -215 -215 0 -215
    0 0 215 0 215 215 0 215 0 0 -215z m1060 50 l0 -25 -395 0 -395 0 0 25 0 25
    395 0 395 0 0 -25z m0 -150 l0 -25 -395 0 -395 0 0 25 0 25 395 0 395 0 0 -25z"
      />
      <path d="M890 775 l0 -155 160 0 160 0 0 155 0 155 -160 0 -160 0 0 -155z" />
    </g>
  ),
});

export const NetworkErrorIcon = createIcon({
  displayName: "NetworkErrorIcon",
  viewBox: "0 0 24 24",
  path: (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 24 24"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"></path>
    </svg>
  ),
});
